/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import ChartTemplate from "../viewer_chart/ChartTemplate";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/
const text_array = [
  "Sangat Sesuai",
  "Sesuai",
  "Cukup Sesuai",
  "Tidak Sesuai",
  "Sangat Tidak Sesuai",
];
const color_array = [
  "rgb(0,107,61)",
  "rgb(128,181,30)",
  "rgb(255,255,0)",
  "rgb(246,137,11)",
  "rgb(237,19,22)",
];
let number_array = [0, 0, 0, 0, 0];

const SS_PIE_CHART_TEMP = ({ insight_reducer }) => {
  //local storage

  //global props
  const { features_grid } = insight_reducer;

  features_grid.forEach((feature) => {
    const value = feature?.properties?.FINAL_STATUS_SCORE;
    const index = text_array.findIndex((item) => item === value);
    number_array[index] = Number(number_array[index]) + 1;
  });
  const chart_js_data = {
    labels: text_array,
    datasets: [
      {
        label: "Site Selection",
        labels: text_array,
        data: number_array,
        backgroundColor: color_array,
        borderColor: "black",
        borderWidth: 1,
      },
    ],
  };

  return (
    <main>
      <ChartTemplate
        type="pie"
        width={100}
        height={100}
        style={{ width: "100px", margin: "auto" }}
        options={{
          animation: false,
          maintainAspectRatio: true,
          responsive: false,
          legend: {
            display: false,
          },
          indexAxis: "x",
          title: {
            display: false,
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
        data={chart_js_data}
      />
    </main>
  );
};

const mapStateToProps = (state) => ({
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {})(SS_PIE_CHART_TEMP);
